import { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import CommonTable from './commonTable';
import { ELITE_QUIZ_TYPE, GAME_LANGUAGES, PER_PAGE } from '../../utils/constants';
import FormSelect from '../common/FormSelect';
import { pageOptions } from '../../utils/dropDownConfig';
import { FunnelIcon } from '@heroicons/react/24/outline';
import SelectMenu from '../common/SelectMenu';
import { Transition } from '@headlessui/react';
import SearchInput from '../common/Input/SearchInput';
import { FormInput } from 'lucide-react';
import { useOutsideClick } from '../../utils/helper';
import { FilterPanel } from '../../component/common/designSystem';
const QuestionsList = ({
  questions,
  categoryList,
  subCategoryList,
  getSubCategories,
  quizType,
  onEdit,
  onView,
  onFilter,
  onDelete,
  limit = 10,
  setLimit,
  onRefresh,
  page,
  dropdowndata,
  setPage
}) => {
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [filteredMainCategoryList, setFilteredMainCategoryList] = useState([]);
  const [filteredSubCategoryList, setFilteredSubCategoryList] = useState([]);
  const [filteredDropDownList, setfilteredDropDownList] = useState([]);

  useEffect(() => {
    const filteredMainCategories = categoryList?.map((cat) => ({
      name: cat.categoryName,
      value: cat._id
    }));
    setFilteredMainCategoryList(filteredMainCategories);
  }, [categoryList]);

  useEffect(() => {
    const filteredMainCategories = dropdowndata?.map((cat) => ({
      name: cat.title,
      value: cat._id
    }));
    setfilteredDropDownList(filteredMainCategories);
  }, [dropdowndata]);

  useEffect(() => {
    const filteredSubCategories = subCategoryList?.map((cat) => ({
      name: cat.categoryName,
      value: cat._id
    }));
    setFilteredSubCategoryList(filteredSubCategories);
  }, [subCategoryList]);

  const [examId, setExamId] = useState('');

  const wrapperRef = useRef(null);
  const [funLearnId, setFunLearnId] = useState('');
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filterCriteria, setFilterCriteria] = useState({
    language: '',
    categoryId: '',
    subCategoryId: '',
    level: ''
  });
  const [selectedPerPage, setSelectedPerPage] = useState(PER_PAGE[0]);
  // const [subCategory, setSubCategory] = useState('');

  const columns = [
    { header: 'ID', accessor: '_id' },
    {
      header: 'Language',
      render: (row) => (
        <span>
          {row.language
            ? row.language.charAt(0).toUpperCase() + row.language.slice(1).toLowerCase()
            : '-'}
        </span>
      )
    },
    {
      header: 'Image',
      render: (row) => {
        return row.image ? <img width={50} src={row.image} /> : 'NA';
      }
    },
    { header: 'Question', accessor: 'question' },
    quizType !== ELITE_QUIZ_TYPE.GUESS_THE_WORD && {
      header: 'Option A',
      render: (row) => row.options?.[0]?.text || 'N/A'
    },
    quizType !== ELITE_QUIZ_TYPE.GUESS_THE_WORD && {
      header: 'Option B',
      render: (row) => row.options?.[1]?.text || 'N/A'
    },
    quizType !== ELITE_QUIZ_TYPE.GUESS_THE_WORD && {
      header: 'Option C',
      render: (row) => row.options?.[2]?.text || 'N/A'
    },
    quizType !== ELITE_QUIZ_TYPE.GUESS_THE_WORD && {
      header: 'Option D',
      render: (row) => row.options?.[3]?.text || 'N/A'
    },
    quizType !== ELITE_QUIZ_TYPE.AUDIO_QUESTIONS &&
      quizType !== ELITE_QUIZ_TYPE.EXAM_MODULE &&
      quizType !== ELITE_QUIZ_TYPE.CONTEST &&
      quizType !== ELITE_QUIZ_TYPE.FUN_N_LEARN &&
      quizType !== ELITE_QUIZ_TYPE.MATH_QUIZ &&
      quizType !== ELITE_QUIZ_TYPE.GUESS_THE_WORD && {
        header: 'Level',
        accessor: 'level'
      },
    {
      header: 'Operate',
      render: (row) => (
        <div className="flex gap-2">
          <button
            className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
            onClick={() => onView(row)}
            title="View"
          >
            <i className="fas fa-eye"></i>
          </button>
          <button
            className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
            onClick={() => onEdit(row)}
            title="Edit"
          >
            <i className="fas fa-edit"></i>
          </button>
          <button
            className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
            title="Delete"
            onClick={() => onDelete(row._id)} // Assuming onDelete is defined to handle deletion
          >
            <i className="fas fa-trash-alt"></i>
          </button>
        </div>
      )
    }
  ];
  useOutsideClick(wrapperRef, () => {
    if (showFilterModal) setShowFilterModal(!showFilterModal);
  });
  const filterHandler = (data, key) => {
    console.log(data, key);
    const newCriteria = {
      ...filterCriteria,
      [key]: data ? data.value : ''
    };
    console.log(newCriteria);
    setFilterCriteria(newCriteria);
  };
  const filterData = () => {
    onFilter(filterCriteria);
    setShowFilterModal(false);
  };
  /**
   * Handle pagination
   * @param {*} page
   */
  const handlePagination = (page) => {
    setPage(page);
  };

  return (
    <div>
      {/* Header */}
      {/* Language Dropdown */}
      <div className="flex flex-wrap items-center gap-6 mb-4">
        <div className="hidden sm:flex mr-3 self-center">
          <span className="self-center md:block hidden text-sm mr-2 text-shoorah-lightBlack dark:text-white">
            {'Per Page:'}
          </span>
          <div className="w-[80px]">
            <SelectMenu
              menuList={PER_PAGE}
              showLabel={false}
              defaultSelected={selectedPerPage}
              setSelectedMenu={(data) => {
                if (setLimit) {
                  setPage(1);
                  setLimit(data.value);
                }
              }}
            />
          </div>
        </div>
        <div className="self-center">
          <SearchInput
            id="searchKey"
            name="searchKey"
            type="text"
            onChange={(e) => {
              const timeoutId = setTimeout(() => {
                onFilter({ search: e.target.value });
              }, 500); // 500ms delay

              return () => clearTimeout(timeoutId);
            }}
            placeholder={'Search by question'}
          />
        </div>

        <div className="ml-auto self-center">
          <button
            className="btn-primary sm:w-auto"
            onClick={() => setShowFilterModal((state) => !state)}
          >
            <FunnelIcon className="text-white w-[18px] h-[20px] inline" />
          </button>
        </div>

        {/* Main Category Dropdown */}

        {/* Sub Category Dropdown */}
        {/* <select
          className="input-company w-full sm:w-1/3"
          value={subCategory}
          onChange={(e) => setSubCategory(e.target.value)}
        >
          <option value="">Select Sub Category</option>
          {subCategoryList.map((sub) => (
            <option key={sub._id} value={sub._id}>
              {sub.categoryName}
            </option>
          ))}
        </select> */}

        {/* Filter Button */}
      </div>
      <FilterPanel
          open={showFilterModal}
          onClose={() => setShowFilterModal(false)}
        >
            <div>
              <SelectMenu
                menuList={GAME_LANGUAGES}
                defaultSelected={GAME_LANGUAGES.find(
                  (lang) => lang.value === filterCriteria.language
                )}
                label="Language"
                isRequired={false}
                setSelectedMenu={(data) => filterHandler(data, 'language')}
              />
            </div>

            {(quizType === ELITE_QUIZ_TYPE.QUIZ_ZONE ||
              quizType === ELITE_QUIZ_TYPE.MULTI_MATCH ||
              quizType === ELITE_QUIZ_TYPE.MATH_QUIZ ||
              quizType === ELITE_QUIZ_TYPE.AUDIO_QUESTIONS ||
              quizType === ELITE_QUIZ_TYPE.GUESS_THE_WORD) && (
              <>
                <SelectMenu
                  menuList={filteredMainCategoryList}
                  label="Main Category"
                  defaultSelected={filteredMainCategoryList.find(
                    (cat) => cat.value == filterCriteria.categoryId
                  )}
                  isRequired={false}
                  setSelectedMenu={(data) => {
                    filterHandler(data, 'categoryId');
                    getSubCategories(data.value);
                  }}
                />
                <SelectMenu
                  menuList={filteredSubCategoryList}
                  defaultSelected={filteredSubCategoryList.find(
                    (cat) => cat.value == filterCriteria.subCategoryId
                  )}
                  label="Sub Category"
                  isRequired={false}
                  setSelectedMenu={(data) => filterHandler(data, 'subCategoryId')}
                />
              </>
            )}
            {(quizType == ELITE_QUIZ_TYPE.QUIZ_ZONE || quizType == ELITE_QUIZ_TYPE.MULTI_MATCH) && (
              <div className="flex flex-col">
                <label className="text-sm font-medium dark:text-white text-gray-700">Level</label>
                <input
                  type="number"
                  value={filterCriteria.level || ''}
                  placeholder="level"
                  className="py-[9px] rounded-3xl dark:bg-shoorah-darkBgTabColor dark:text-white dark:border-shoorah-darkBorder pl-4 w-100 appearance-none border-[1.5px] border-shoorah-borderGray px-3 placeholder-gray-400 placeholder:text-sm focus:border-shoorah-primary focus:outline-none focus:ring-shoorah-primary sm:text-sm !leading-[22px]"
                  onChange={(e) => {
                    filterHandler({ value: e.target.value }, 'level');
                  }}
                />
              </div>
            )}
            {quizType === ELITE_QUIZ_TYPE.EXAM_MODULE && (
              <SelectMenu
                menuList={filteredDropDownList}
                defaultSelected={filteredDropDownList.find(
                  (cat) => cat.value == filterCriteria.funLearnId
                )}
                label="Sub Category"
                isRequired={false}
                setSelectedMenu={(data) => filterHandler(data, 'subCategoryId')}
              />
            )}
            {quizType === ELITE_QUIZ_TYPE.FUN_N_LEARN && (
              <select
                className="input-company w-full sm:w-1/3"
                value={funLearnId}
                onChange={(e) => {
                  setFunLearnId(e.target.value);
                }}
              >
                <option value="">Fun N Learn </option>
                {dropdowndata?.map((funNLearn) => (
                  <option key={funNLearn._id} value={funNLearn._id}>
                    {funNLearn.title}
                  </option>
                ))}
              </select>
            )}
            {/* <div>
                      <SelectMenu
                        menuList={RATING_DROPDOWN}
                        defaultSelected={filterCriteria.ratings}
                        label="Ratings"
                        isRequired={false}
                        setSelectedMenu={(data) => filterHandler(data, 'ratings')}
                      />
                    </div> */}
          </FilterPanel>

      {/* Search and actions */}

      <CommonTable
        columns={columns}
        data={questions}
        currentPage={page}
        itemsPerPage={limit} // Assuming you want to start from page 1
        totalItems={questions?.meta?.pagination?.totalItems}
        pagination={true}
        onPageChange={handlePagination}
      />
    </div>
  );
};

export default QuestionsList;
